<template>
    <div class="smartscan-switch">
        <b-form-checkbox v-model="smartScanOn" @change="updateScanningOption" switch>
            <div id="tt-smart-scan">
                <span class="title" v-translate>SmartScan</span>
                <span class='ai-icon'>Ai</span>
            </div>
            <b-tooltip :custom-class="'tooltip-padded'" target="tt-smart-scan" placement="top" triggers="hover">
                <div class="tooltip-title">
                    {{ $gettext('Smart Scan') }}
                </div>
                <div class="tooltip-text">
                    {{ popupText }}
                </div>
            </b-tooltip>
        </b-form-checkbox>
    </div>
</template>
<script>
    import ProfileService from "@/store/services/profile.service.js";

    export default {
        name: "SmartScanSwitch",
        props: {},
        data() {
            return {
                smartScanOn: false,
                popupText: this.$gettext("Gekko uses smart scanning of receipts to automatically read and interpret the information on your receipt. This saves you the hassle of having to copy information manually from the digital receipt to your account.")
            }
        },
        created(){
            let vm = this;
            ProfileService.getCurrent().then(function (response) {
                vm.smartScanOn = response.data.smart_scan;
                if(!vm.$store.getters['getIsPremium']){
                    vm.smartScanOn = false;
                }
            })
        },
        methods: {
            updateScanningOption(){
                if(!this.$store.getters['getIsPremium']){
                    this.smartScanOn = false;
                    this.$store.commit('togglePremiumModal', 'web_costs_smartscan');
                    return;
                }
                ProfileService.toggleSmartScan();
                this.$emit("change", this.smartScanOn);
            }
        }
    };
</script>
<style lang="scss">
    .smartscan-switch {
        .custom-switch {
            cursor: pointer;
            > .custom-control-label {
                cursor: pointer;
            }
        }
    }   
</style>
<style lang="scss" scoped>
    .smartscan-switch {
        font-size: 16px;
        padding: 5px 10px;
        border: 1px solid #ececec;
        background: white;
        border-radius: $radiusMd;
        cursor: pointer;
        height: 40px;
        display: flex;
        align-items: center;
        .title {
            margin-right: 5px;
        }
        .ai-icon{
            background: $colorBrand;
            color: white;
            border-radius: $radiusSm;
            padding: 4px;
            padding-bottom: 3px;
            font-size: 13px;
        }
    }

</style>